var tocGuideJS = (function () {
  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    var parentHeading = document.querySelector('.guide-content'),
      parentBlock = document.querySelector('.guide-toc__list'),
      tocBlock = document.querySelector('.guide-toc'),
      allHeading = parentHeading.querySelectorAll('h2:not(.hide-toc-heading), h3:not(.hide-toc-heading), h4:not(.hide-toc-heading)');
      
    if (!tocBlock) {
      return false;
    }

    // retrun if heading list is less than 3 or greater than 20
    if (allHeading.length < 3 || allHeading.length > 30) {
      tocBlock.remove();
      return false;
    }

    for (var i = 0; i < allHeading.length; i++) {
      var clearInnerHeading = allHeading[i].innerHTML.replace(/\n|<.*?>/g,'');
      if (allHeading[i].nodeName == 'H2' || allHeading[i].nodeName == 'H3') {
        if(clearInnerHeading) {
          if (i == 0) {
            allHeading[i].setAttribute("id", "toc0");
          } else {
            allHeading[i].setAttribute("id", "toc" + i);
          }
        }
      }

      if (allHeading[i].nodeName == 'H4') {
        if(clearInnerHeading) {
          allHeading[i].setAttribute("id", "toc" + i);
        }
      }
    }

    // Remove unwanted anchor tag
    var anchors = parentBlock.getElementsByTagName("a");
    for(var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      if(anchor.innerHTML == "") {
        anchor.parentNode.removeChild(anchor); //removes the anchor
      }
    }
  };

  init();
})();
